import { createSelector } from 'reselect'

export const resultsAvailableSelector = createSelector(
  state => state.searchResults.creatorResults,
  state => state.searchResults.allResults,
  ({ loading: loadingCreators, creators}, { loading: loadingAll }) => {
    return (!loadingCreators && creators.length && loadingAll) || !loadingAll
  }
)
